import type { IApiResponse } from '@/interfaces/IApiResponse'
import type { FullBalance } from '@/interfaces/IFullBalance'
import { amountHelper } from '@nami/domain/classes'
import { toRefs } from 'vue'
import useAxios from '@/composable/useAxios'
import { useGlobalStore } from '@/stores/globalStore'
import { useUserStore } from '@/stores/userStore'

export const balanceApi = {
    get: async (): Promise<string> => {
        const globalStore = useGlobalStore()
        const { userInfo } = toRefs(useUserStore())
        const { data } = await useAxios.get<number>('/balance', { noLoading: true })
        globalStore.setBalanceNumber(data)
        globalStore.setBalance(amountHelper.getLocaleStringWithSymbol(data, userInfo.value.currency.toString(), 2))

        return globalStore.balanceDisplay
    },
}

export const withdrawableAmountApi = {
    get: async (): Promise<number> => {
        const { data } = await useAxios.get<WithdrawAmountResponse>('/v2/withdrawable-amount', { noLoading: true })
        const globalStore = useGlobalStore()
        globalStore.setWithdrawableAmount(data.withdrawableAmount)
        globalStore.setLastUpdateTime(data.betCheckTime)
        return globalStore.withdrawableAmountNumber
    },
}

export const refreshWithdrawableAmountApi = {
    post: async (): Promise<void> => {
        await useAxios.post('/refresh-withdrawable-amount', { noLoading: true })
    },
}

export interface WithdrawAmountResponse {
    withdrawableAmount: number
    betCheckTime: Date
}

export const accountBalanceApi = {
    get: async (customerId: number): Promise<FullBalance> => {
        const {
            data: { data },
        } = await useAxios.get<IApiResponse<FullBalance>>(`/account-balance?customerId=${customerId}`, { noLoading: true })
        return data
    },
}
